import AxiosInstance from "../instance";

const startCrossProviderJob = async (data: any) => {
    const response = await AxiosInstance.getInstance().post("/crossprovider", data);
    return response;
};

const getCrossProviderJobResult = async (jobId: string, responseType: string) => {
    const response = await AxiosInstance.getInstance().get("/crossprovider", {
        params: {
            id: jobId
        },
        responseType
    });

    return response;
};

export {startCrossProviderJob, getCrossProviderJobResult};


// WEBPACK FOOTER //
// ./src/api/models/CrossProvider.ts